import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';

const PagosFiltros = ({ 
    dateQuarter, setDateQuarter,
    idVendedor, setIDVendedor,
    idCatCuentaBancaria, setIdCatCuentaBancaria,
    idCatMedioPago, setIdCatMedioPago,
    filterValidados, setFilterValidados,
    filterStatus, setFilterStatus
}) => {
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [vendedores, setVendedores] = useState([]);
    const [cuentas, setCuentas] = useState([]);
    const [mediosPago, setMediosPago] = useState([]);
    const [cargandoCatalogos, setCargandoCatalogos] = useState(true);

    useEffect(() => {
        ObtenerFiltros();
    }, []);

    const ObtenerFiltros = async () => {
        setCargandoCatalogos(true);
        const response = await fetch("/api/AdministracionPagos/ObtenerPagosFiltros/", {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('' + error.message);
        });

        if (response && response.ok) {
            const objResponse = await response.json();
            if (objResponse.iResponseType == 1) {
                const data = JSON.parse(objResponse.detalles);
                setVendedores(data['table2'] || []);
                setMediosPago(data['table3'] || []);
                setCuentas(data['table4'] || []);
            } else {
                showErrorToast(objResponse.vMessage);
            }
        } else if (response && response.status == 401) {
            setToken(null);
            window.location.href = "";
        }
        setCargandoCatalogos(false);
    };

    return (
        <div className="card rounded-4 mb-3 border border-200 shadow-none" style={{ position: 'relative', zIndex: 100 }}>
            <div className="card-body p-3">
                <Row className="g-3">
                    <Col xs={12} md={4} lg={2}>
                        {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700 fs--2 fw-bold text-uppercase mb-1">Mes</Form.Label>}
                        {cargandoCatalogos ? <Skeleton /> :
                            <DatePicker
                                selected={dateQuarter}
                                onChange={(date) => {
                                    sessionStorage.setItem("selectMes", date);
                                    setDateQuarter(date);
                                }}
                                dateFormat="MMMM yyyy - QQQ"
                                className="form-control form-control-sm w-100"
                                showMonthYearPicker
                            />
                        }
                    </Col>

                    <Col xs={12} md={4} lg={2}>
                        {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700 fs--2 fw-bold text-uppercase mb-1">Vendedores</Form.Label>}
                        {cargandoCatalogos ? <Skeleton /> :
                            <Form.Select
                                size="sm"
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                    setIDVendedor(e.target.value);
                                    sessionStorage.setItem("selectIDUsuario", e.target.value);
                                }}
                                value={idVendedor}
                            >
                                <option value="">Todos los vendedores</option>
                                {vendedores.map((vendedor, i) => (
                                    <option key={i} value={vendedor.idUsuario}>{vendedor.vNombre + ' ' + vendedor.vApellidos}</option>
                                ))}
                            </Form.Select>
                        }
                    </Col>

                    <Col xs={12} md={4} lg={2}>
                        {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700 fs--2 fw-bold text-uppercase mb-1">Cuentas</Form.Label>}
                        {cargandoCatalogos ? <Skeleton /> :
                            <Form.Select
                                size="sm"
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                    setIdCatCuentaBancaria(e.target.value);
                                    sessionStorage.setItem("ctaBancariaConciliacion", e.target.value);
                                }}
                                value={idCatCuentaBancaria}
                            >
                                <option value="">Todas las cuentas</option>
                                {cuentas.map((cta, i) => (
                                    <option key={i} value={cta.idCatCuentaBancaria}>{cta.vNumCta}-{cta.vAlias}</option>
                                ))}
                            </Form.Select>
                        }
                    </Col>

                    <Col xs={12} md={4} lg={2}>
                        {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700 fs--2 fw-bold text-uppercase mb-1">Medio de Pago</Form.Label>}
                        {cargandoCatalogos ? <Skeleton /> :
                            <Form.Select
                                size="sm"
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                    setIdCatMedioPago(e.target.value);
                                    sessionStorage.setItem("idMedioPago", e.target.value);
                                }}
                                value={idCatMedioPago}
                            >
                                <option value="">Todos los medios</option>
                                {mediosPago.map((medioPago, i) => (
                                    <option key={i} value={medioPago.idCatMedioPago}>{medioPago.idCatMedioPago}-{medioPago.vMedioPago}</option>
                                ))}
                            </Form.Select>
                        }
                    </Col>

                    <Col xs={12} md={4} lg={2}>
                        <Form>
                            {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700 fs--2 fw-bold text-uppercase mb-1">Validados</Form.Label>}
                            {cargandoCatalogos ? <Skeleton /> :
                                <Form.Select
                                    size="sm"
                                    className="form-control form-control-sm"
                                    onChange={(e) => {
                                        setFilterValidados(e.target.value);
                                    }}
                                    value={filterValidados}
                                >
                                    <option value="-1">TODOS</option>
                                    <option value="1">Validados</option>
                                    <option value="0">No Validados</option>
                                </Form.Select>
                            }
                        </Form>
                    </Col>

                    <Col xs={12} md={4} lg={2}>
                        <Form>
                            {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700 fs--2 fw-bold text-uppercase mb-1">Estatus</Form.Label>}
                            {cargandoCatalogos ? <Skeleton /> :
                                <Form.Select
                                    size="sm"
                                    className="form-control form-control-sm"
                                    onChange={(e) => {
                                        setFilterStatus(e.target.value);
                                    }}
                                    value={filterStatus}
                                >
                                    <option value="-1">TODOS</option>
                                    <option value="1">Activos</option>
                                    <option value="0">Cancelados</option>
                                </Form.Select>
                            }
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

PagosFiltros.propTypes = {
    dateQuarter: PropTypes.instanceOf(Date).isRequired,
    setDateQuarter: PropTypes.func.isRequired,
    idVendedor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setIDVendedor: PropTypes.func.isRequired,
    idCatCuentaBancaria: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setIdCatCuentaBancaria: PropTypes.func.isRequired,
    idCatMedioPago: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setIdCatMedioPago: PropTypes.func.isRequired,
    filterValidados: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setFilterValidados: PropTypes.func.isRequired,
    filterStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setFilterStatus: PropTypes.func.isRequired
};

export default PagosFiltros;
